import * as React from 'react'
import Radio, { RadioProps } from '@mui/material/Radio'

type LocalProps = {
  input?: Record<string, any>
  meta?: Record<string, string>
}

const RadioWrapper: React.ComponentType<LocalProps & RadioProps> = ({
  input: { checked, value, name, onChange, ...restInput },
  ...rest
}) => (
  <Radio
    {...rest}
    name={name}
    inputProps={restInput}
    onChange={onChange}
    checked={checked}
    value={value}
    color={'primary'}
  />
)

export default RadioWrapper
